export const sequentialNotificationsCount = 3;
export const periodicalNotificationsCount = 2;
export const maxNotificationsCount = sequentialNotificationsCount + periodicalNotificationsCount;

export const daysShouldPassPerNotification = [30, 90];
